import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../services/admin/AdminAuthServices';

/**
 * AdminProtectedRoutes
 * Decorator component to protect admin routes.
 * Redirects to login if the admin is not authenticated.
 * Passes both React Router state AND ?next= query param so AdminLogin
 * can handle redirects regardless of how the user arrived at login.
 */
const AdminProtectedRoutes = ({ children }) => {
    const { admin } = useAdminAuth();
    const location = useLocation();

    if (!admin) {
        const nextPath = encodeURIComponent(`${location.pathname}${location.search}`);
        return (
            <Navigate
                to={`/admin/login/?next=${nextPath}`}
                state={{ from: location }}
                replace
            />
        );
    }

    return children;
};

export default AdminProtectedRoutes;
